import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-108">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-109" />

      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden z-10" data-id="element-110">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-tea-sage/30" data-id="element-111">
          <h2 className="text-xl font-heading font-bold text-tea-green" data-id="element-112">
            {title}
          </h2>
          <button onClick={onClose} className="w-8 h-8 rounded-full bg-tea-sage/30 flex items-center justify-center text-tea-charcoal/60 hover:bg-tea-sage/50 transition-colors" aria-label="Cerrar" data-id="element-113">
            <XIcon className="w-4 h-4" data-id="element-114" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-tea-charcoal/80 text-sm leading-relaxed space-y-4" data-id="element-115">
          {children}
        </div>
      </div>
    </div>;
}
export function FooterSection() {
  const currentYear = new Date().getFullYear();
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer className="bg-tea-charcoal text-tea-cream/60 py-12 px-6 text-center text-sm font-light" data-id="element-116">
        <div className="max-w-4xl mx-auto" data-id="element-117">
          <p className="mb-6" data-id="element-118">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>

          <div className="flex items-center justify-center gap-4 mb-6" data-id="element-119">
            <button onClick={() => setPrivacyOpen(true)} className="underline underline-offset-2 hover:text-tea-gold transition-colors" data-id="element-120">
              Política de Privacidad
            </button>
            <span className="text-tea-cream/30" data-id="element-121">|</span>
            <button onClick={() => setTermsOpen(true)} className="underline underline-offset-2 hover:text-tea-gold transition-colors" data-id="element-122">
              Términos y Condiciones
            </button>
          </div>

          <p data-id="element-123">
            &copy; {currentYear} El Negocio del Té. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-124">
        <p data-id="element-125">
          <strong data-id="element-126">Última actualización:</strong> Marzo 2026
        </p>

        <p data-id="element-127">
          En El Negocio del Té ("nosotros", "nuestro"), respetamos tu privacidad
          y nos comprometemos a proteger tus datos personales. Esta política
          describe cómo recopilamos, usamos y protegemos tu información.
        </p>

        <h3 className="font-heading font-bold text-tea-green text-base mt-4" data-id="element-128">
          1. Información que recopilamos
        </h3>
        <p data-id="element-129">
          Recopilamos la información que nos proporcionas directamente al
          realizar una compra: nombre, dirección de correo electrónico y datos
          de pago. Los datos de pago son procesados de forma segura por nuestro
          procesador de pagos externo y no almacenamos información de tarjetas
          de crédito.
        </p>

        <h3 className="font-heading font-bold text-tea-green text-base mt-4" data-id="element-130">
          2. Uso de la información
        </h3>
        <p data-id="element-131">
          Utilizamos tu información para: procesar tu compra y entregarte el
          producto digital, enviarte comunicaciones relacionadas con tu compra,
          y mejorar nuestros productos y servicios.
        </p>

        <h3 className="font-heading font-bold text-tea-green text-base mt-4" data-id="element-132">
          3. Protección de datos
        </h3>
        <p data-id="element-133">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado,
          alteración o destrucción.
        </p>

        <h3 className="font-heading font-bold text-tea-green text-base mt-4" data-id="element-134">
          4. Compartir información
        </h3>
        <p data-id="element-135">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros, excepto a proveedores de servicios necesarios para procesar
          tu compra (procesadores de pago, servicios de entrega de contenido
          digital).
        </p>

        <h3 className="font-heading font-bold text-tea-green text-base mt-4" data-id="element-136">
          5. Cookies
        </h3>
        <p data-id="element-137">
          Utilizamos cookies y tecnologías similares para mejorar tu experiencia
          de navegación y analizar el tráfico del sitio.
        </p>

        <h3 className="font-heading font-bold text-tea-green text-base mt-4" data-id="element-138">
          6. Tus derechos
        </h3>
        <p data-id="element-139">
          Tienes derecho a acceder, rectificar o eliminar tus datos personales.
          Para ejercer estos derechos, contáctanos a través de nuestro correo
          electrónico.
        </p>

        <h3 className="font-heading font-bold text-tea-green text-base mt-4" data-id="element-140">
          7. Contacto
        </h3>
        <p data-id="element-141">
          Si tienes preguntas sobre esta política de privacidad, puedes
          contactarnos a través de nuestras redes sociales o correo electrónico
          oficial.
        </p>
      </LegalModal>

      {/* Terms of Service Modal */}
      <LegalModal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-142">
        <p data-id="element-143">
          <strong data-id="element-144">Última actualización:</strong> Marzo 2026
        </p>

        <p data-id="element-145">
          Al acceder y utilizar este sitio web y adquirir nuestros productos
          digitales, aceptas los siguientes términos y condiciones.
        </p>

        <h3 className="font-heading font-bold text-tea-green text-base mt-4" data-id="element-146">
          1. Producto digital
        </h3>
        <p data-id="element-147">
          "El Negocio del Té" es un producto 100% digital que incluye guías,
          recetarios, herramientas y bonus descargables. No se envía ningún
          producto físico. El acceso se otorga de forma inmediata tras la
          confirmación del pago.
        </p>

        <h3 className="font-heading font-bold text-tea-green text-base mt-4" data-id="element-148">
          2. Licencia de uso
        </h3>
        <p data-id="element-149">
          Al comprar, recibes una licencia personal e intransferible para uso
          propio. Queda prohibida la reproducción, distribución, reventa o
          compartición del material con terceros.
        </p>

        <h3 className="font-heading font-bold text-tea-green text-base mt-4" data-id="element-150">
          3. Garantía de devolución
        </h3>
        <p data-id="element-151">
          Ofrecemos una garantía de satisfacción de 7 días. Si dentro de los
          primeros 7 días calendario desde tu compra no estás satisfecho/a con
          el producto, puedes solicitar un reembolso completo sin necesidad de
          justificación. Pasado este período, no se aceptan solicitudes de
          devolución.
        </p>

        <h3 className="font-heading font-bold text-tea-green text-base mt-4" data-id="element-152">
          4. Resultados
        </h3>
        <p data-id="element-153">
          Los resultados mencionados en este sitio son ejemplos reales de
          clientes, pero no garantizamos resultados específicos. El éxito
          depende del esfuerzo, dedicación y aplicación individual de cada
          persona.
        </p>

        <h3 className="font-heading font-bold text-tea-green text-base mt-4" data-id="element-154">
          5. Propiedad intelectual
        </h3>
        <p data-id="element-155">
          Todo el contenido de este sitio web y del producto digital (textos,
          imágenes, diseños, recetas, herramientas) es propiedad de El Negocio
          del Té y está protegido por las leyes de propiedad intelectual.
        </p>

        <h3 className="font-heading font-bold text-tea-green text-base mt-4" data-id="element-156">
          6. Modificaciones
        </h3>
        <p data-id="element-157">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones serán efectivas desde su publicación en
          este sitio.
        </p>

        <h3 className="font-heading font-bold text-tea-green text-base mt-4" data-id="element-158">
          7. Contacto
        </h3>
        <p data-id="element-159">
          Para consultas sobre estos términos, puedes contactarnos a través de
          nuestras redes sociales o correo electrónico oficial.
        </p>
      </LegalModal>
    </>;
}